import React from 'react'

export const renderDropdown = ({ displayType, input, placeholder, label, icon, type, meta: { touched, error, warning } }) => { 
  console.log('renderDropdown', input.value)
  return (
    <div className='dt-inputForm-block'>
      <div className='dt-inputText'>{label}</div>
      <div className={icon}>
        {/* <input {...input} placeholder={placeholder} type={type} className='dt-input dt-input-fix'/> */}
        { (() => {
          if(displayType === 'view') {
            return <input disabled type='text' className='dt-input dt-input-w100' value={input.value === 1 ? 'Admin' : input.value === 2 ? 'User' : 'Token'} readOnly />
          } else {
            return (
              <div className='dt-select dt-select-fix dt-input-w100'>
                <select {...input}>
                  <option value=''></option>
                  <option value='1'>Admin</option>
                  <option value='2'>User</option>
                  <option value='3'>Token</option>
                </select>
              </div>
            )
          }
        })() }
        
      </div>
      {touched ? ((error && <span className='dt-inputMessage --show'>{error}</span>) || (warning && <span className='dt-inputMessage --show'>{warning}</span>)) : <span className='dt-inputMessage' />}
    </div>
  )
}
